import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
var ImportPhonebookContactDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ImportPhonebookContactDialogComponent(dialogRef, data, configService, cookieService, toastrService, translateService, companiesService, authService, helperService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.companiesService = companiesService;
        this.authService = authService;
        this.helperService = helperService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add phonebook contact form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.import'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
        // END - Add phonebook contact form
        this.dialogIsLoading = true;
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     */
    ImportPhonebookContactDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Init add form
        this.initForm();
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ImportPhonebookContactDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    ImportPhonebookContactDialogComponent.prototype.initForm = function () {
        // Set model
        this.model = this.model;
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: "col-12 col-sm-6",
                        type: "file-uploader",
                        key: "files",
                        templateOptions: {
                            required: false,
                            label: this.translateService.instant('companies.detail.importPhoneBook.file'),
                            allowedFilesNumber: 1,
                            allowedFilesExtensions: 'xlsx',
                            bindLabel: "originalName",
                        }
                    },
                    {
                        className: "col-12 col-sm-6",
                        template: '<div>' + this.translateService.instant('companies.detail.importPhoneBook.description') + '</div>',
                    },
                ],
            },
        ]);
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     * @param [data] optional data passed to the caller component
     */
    ImportPhonebookContactDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    ImportPhonebookContactDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            // this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        this.subscriptions.push(this.companiesService.importPhonebookContact(this.data.companyId, model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose({ createdPhonebookContact: true });
                return;
            }
            // this.toastrService.error(this.translateService.instant('common.errors.unknown_server_error'));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    return ImportPhonebookContactDialogComponent;
}());
export { ImportPhonebookContactDialogComponent };
